import TargetApiUrlAndPath from "../../utils/webApi/TargetApiUrlAndPath";
import LocalStorageDataStorer from "../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../dataAccessLayer/localStorage/LocalStorageKey";
import SessionDataStorer from "../../dataAccessLayer/session/SessionDataStorer";
import SessionKey from "../../dataAccessLayer/session/SessionKey";
import HttpRequestMethod from "../../utils/enumerations/HttpRequestMethod";
import FetchAPI from "./FetchAPI";



function getUrl(path){
    const safePort = ( TargetApiUrlAndPath.HTTP_PORT) ? ":" + TargetApiUrlAndPath.HTTP_PORT : "";
    const url = TargetApiUrlAndPath.HOSTNAME + safePort + path;
    //console.log("function-getUrl()-url: ", url);
    return url;
}

const GETMethod = function (url, responseCallback, selectedHeaders = null) {
    const options = {
        method: HttpRequestMethod[HttpRequestMethod.GET],
        mode:'cors',
        credentials: 'include', // THIS IS MANDATORY
        headers: getHeaders(selectedHeaders)
    }
    //console.log('fetchMethod-url', url);
    //console.log('fetchMethod-options', options);
    FetchAPI.fetchMethod(url, options, responseCallback);
}

const POSTMethod = function (url, payload, responseCallback, selectedHeaders = null) {
    const payloadJson = JSON.stringify(payload);

    const options = {
        method: HttpRequestMethod[HttpRequestMethod.POST],
        mode:'cors',
        credentials: 'include', // THIS IS MANDATORY
        cache: "no-cache",        
        headers: getHeaders(selectedHeaders),
        body: payloadJson
    }

    FetchAPI.fetchMethod(url, options, responseCallback);
}

const PUTMethod = function (url, payload, responseCallback, selectedHeaders = null) {
    const payloadJson = JSON.stringify(payload);

    const options = {
        method: HttpRequestMethod[HttpRequestMethod.PUT],
        mode:'cors',
        credentials: 'include', // THIS IS MANDATORY
        cache: "no-cache",        
        headers: getHeaders(selectedHeaders),
        body: payloadJson
    }

    FetchAPI.fetchMethod(url, options, responseCallback);
}

const DELETEMethod = function (url,IDsForDeletion, responseCallback, selectedHeaders = null) {
    const urlDeletionPath = url;
    const payloadJson = JSON.stringify(IDsForDeletion);

    let options = {
        method: HttpRequestMethod[HttpRequestMethod.DELETE],
        mode:'cors',
        credentials: 'include', // THIS IS MANDATORY
        headers: getHeaders(selectedHeaders),
        body: payloadJson
    }

    FetchAPI.fetchMethod(urlDeletionPath, options, responseCallback);
}

const HttpRequestService = Object.freeze({
    GETMethod : GETMethod,
    POSTMethod : POSTMethod,
    PUTMethod : PUTMethod,
    DELETEMethod : DELETEMethod,
    getUrl : getUrl
});

export default HttpRequestService;

//#region Private Functions BEGIN
function getHeaders(selectedHeadersObj) {
    const defaultHeadersObj = Object.freeze({
        'Accept': 'application/json',
        'Content-Type':'application/json',
        'Authorization': 'Bearer ' + getJwtToken(),
        'X-Session-ID': getSessionID(),
        'x_csrf_token_key_': getXCsrfTokenKey(),
        'x_csrf_token_client' : getXCsrfTokenClient()
    });

    const headers = Object.assign({},defaultHeadersObj,selectedHeadersObj)

    return headers;
}

function getJwtToken(){
    return LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.jwtUserToken);
}

function getSessionID(){
    return SessionDataStorer.getSessionFromCookieStorage(SessionKey.sessionID);
}

function getXCsrfTokenKey(){
    return SessionDataStorer.getSessionFromCookieStorage(SessionKey.x_csrf_token_key_);
}

function getXCsrfTokenClient(){
    return SessionDataStorer.getSessionFromCookieStorage(SessionKey.x_csrf_token_client);
}


//#endregion Private Functions END